import "./login.css";
import Button from 'react-bootstrap/Button'
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
import CNSP from "../../Images/CNSP_Logo.gif"

import React, { useState } from 'react';
import axios from 'axios';
import { resolvePath, Navigate, useNavigate} from "react-router-dom";
import {SHA256} from 'crypto-js'


const LoginPage = () => {
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');
  const [correct, setCorrect] = useState(false);
  const [token, setToken] = useState('');
  const apiUrl = process.env.REACT_APP_URL;
  const homeUrl = "/home"
  const navigate = useNavigate();

  const handleLogin = async () => {
    const hashedPassword = SHA256(password).toString()
    try {
    const response = await axios.post(apiUrl + '/login', {hashedPassword});
    
      localStorage.setItem('token', '');
      if(response.data.message === 'Success'){
        setError('');
        setToken(response.data.message); // Assume the API returns a token
        localStorage.setItem('token', 'Success'); // Store the token in local storage
        setCorrect(true);
        navigate('/home');
      } else {
        setError('Invalid credentials. Please try again.');
        setCorrect(false);
      }
    } catch {
      setError('Invalid credentials. Please try again.');
    }
    
  };

  return (
    <div>
      <h2>Password protected</h2>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div>
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <button onClick={handleLogin}>Login</button>
    </div>
    
  );
};

export default LoginPage;
